const surveyEndRedirectPage = 'thank-you-redirect';

export default surveyEndRedirectPage;
